import { render, staticRenderFns } from "./SingleElimination.vue?vue&type=template&id=1e6d3a24&scoped=true&"
import script from "./SingleElimination.vue?vue&type=script&lang=js&"
export * from "./SingleElimination.vue?vue&type=script&lang=js&"
import style0 from "./SingleElimination.vue?vue&type=style&index=0&id=1e6d3a24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6d3a24",
  null
  
)

export default component.exports